// extracted by mini-css-extract-plugin
export default {"tableWrap":"StockTable_tableWrap__6Ge5o","tableHeader":"StockTable_tableHeader__22oaF"};